import React, { useState, useEffect /*, useRef */ } from 'react';
import '../SpaSite.css';
import './PromotionsPage.css';

/* 舊版母親節輪播圖（保留以便日後還原）
const promotionImages = [
    { id: 1, image: 'mom1.jpg', alt: '優惠活動 1' },
    { id: 2, image: 'mom2.png', alt: '優惠活動 2' },
    { id: 3, image: 'mom3.png', alt: '優惠活動 3' },
    { id: 4, image: 'mom4.jpg', alt: '優惠活動 4' },
    { id: 5, image: 'mom5.jpg', alt: '優惠活動 5' },
    { id: 6, image: 'mom6.jpg', alt: '優惠活動 6' },
    { id: 7, image: 'mom7.png', alt: '優惠活動 7' }
];
*/

const promotionImages = [
    { id: 1, image: '2026 summer_sales 2.jpg', alt: '京采周年慶優惠 1' },
    { id: 2, image: '2026 summer_sales 1.jpg', alt: '京采周年慶優惠 2' }
];

const colors = {
    primary: '#1a1a1a',
    secondary: '#4c956c',
    accent: '#d9f2b4',
    light: '#f8faf5',
    neutral: '#336F4D',
    neutralLight: '#505151',
    cream: '#fffaf0',
    textDark: '#333'
};

export default function PromotionsPage() {
    const [animatedElements, setAnimatedElements] = useState({});
    const [selectedImage, setSelectedImage] = useState(null);
    /* 輪播相關狀態（保留以便日後還原）
    const [isHovering, setIsHovering] = useState(false);
    const sliderRef = useRef(null);

    const getScrollAmount = () => {
        if (sliderRef.current && sliderRef.current.children.length > 0) {
            const firstChild = sliderRef.current.children[0];
            return firstChild.offsetWidth + 20;
        }
        return window.innerWidth > 768 ? 400 : 300;
    };

    const scrollSlider = (direction) => {
        if (sliderRef.current) {
            const itemWidth = getScrollAmount();
            const currentScroll = sliderRef.current.scrollLeft;
            const currentIndex = Math.round(currentScroll / itemWidth);
            const targetScroll = (currentIndex + direction) * itemWidth;
            sliderRef.current.scrollTo({ left: targetScroll, behavior: 'smooth' });
        }
    };

    // 自動輪播邏輯
    useEffect(() => {
        if (isHovering || selectedImage !== null) return;

        const interval = setInterval(() => {
            if (sliderRef.current) {
                const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;

                if (scrollLeft + clientWidth >= scrollWidth - 10) {
                    sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    const itemWidth = getScrollAmount();
                    const currentIndex = Math.round(scrollLeft / itemWidth);
                    const targetScroll = (currentIndex + 1) * itemWidth;
                    sliderRef.current.scrollTo({ left: targetScroll, behavior: 'smooth' });
                }
            }
        }, 3000); // 每 3 秒自動播放一次

        return () => clearInterval(interval);
    }, [isHovering, selectedImage]);
    */

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setAnimatedElements((prev) => ({
                            ...prev,
                            promotions: true
                        }));
                    }
                });
            },
            { threshold: 0.1 }
        );

        const section = document.getElementById('promotions');
        if (section) observer.observe(section);

        return () => {
            if (section) observer.unobserve(section);
        };
    }, []);

    const openImageModal = (image) => {
        setSelectedImage(image);
        document.body.style.overflow = 'hidden';
    };

    const closeImageModal = () => {
        setSelectedImage(null);
        document.body.style.overflow = 'auto';
    };

    return (
        <section
            id="promotions"
            className="animate-on-scroll"
            style={{
                padding: '6rem 2rem',
                minHeight: '100vh',
                textAlign: 'center',
                background: 'linear-gradient(180deg, rgba(255,250,240,0.7) 0%, rgba(248,250,245,0.9) 100%)',
                fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
                color: colors.textDark
            }}
        >
            {/* 頁面標題 */}
            <h2 className="section-title" style={{
                fontSize: '2rem',
                fontWeight: 600,
                lineHeight: '1.4',
                fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
                color: colors.primary,
                opacity: animatedElements['promotions'] ? 1 : 0,
                transform: animatedElements['promotions'] ? 'translateY(0)' : 'translateY(20px)',
                transition: 'all 1s ease',
            }}>
                京采周年慶優惠
                <div style={{
                    width: '500px',
                    height: '2px',
                    background: 'linear-gradient(90deg, #5C8989, rgba(92, 137, 137, 0.3))',
                    margin: '0.5rem auto 2rem',
                    borderRadius: '1px',
                }} />
            </h2>

            <p style={{
                fontSize: '1.1rem',
                color: colors.neutralLight,
                maxWidth: '600px',
                margin: '0 auto 3rem',
                lineHeight: '1.6',
                fontWeight: 600,
                opacity: animatedElements['promotions'] ? 1 : 0,
                transition: 'opacity 1.2s ease 0.3s'
            }}>
                更多優惠詳請加Line詢問 @jingcaispa
            </p>

            {/* 靜態兩張優惠圖 */}
            <div className="promo-static-gallery">
                {promotionImages.map((promo, index) => (
                    <div
                        key={promo.id}
                        className="promo-static-item"
                        onClick={() => openImageModal(promo)}
                        style={{
                            opacity: animatedElements['promotions'] ? 1 : 0,
                            transform: animatedElements['promotions'] ? 'translateY(0)' : 'translateY(30px)',
                            transitionDelay: `${index * 0.1}s`,
                        }}
                    >
                        <img
                            src={`/assets/img/${encodeURIComponent(promo.image)}`}
                            alt={promo.alt}
                        />
                        <div className="hover-overlay" style={{
                            position: 'absolute',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                            color: 'white',
                            padding: '2rem 1rem 1rem',
                            opacity: 0,
                            transition: 'opacity 0.3s ease',
                        }}>
                            <p style={{
                                fontSize: '0.9rem',
                                margin: 0,
                                fontWeight: 500,
                            }}>
                                點擊查看詳情
                            </p>
                        </div>
                    </div>
                ))}
            </div>

            {/* 舊版輪播 UI（保留以便日後還原）
            <div
                style={{ position: 'relative', maxWidth: '1200px', margin: '0 auto' }}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onTouchStart={() => setIsHovering(true)}
                onTouchEnd={() => setIsHovering(false)}
                onTouchCancel={() => setIsHovering(false)}
            >
                <button
                    className="slider-nav-btn slider-left"
                    onClick={() => scrollSlider(-1)}
                    aria-label="Previous"
                >
                    ‹
                </button>

                <div
                    ref={sliderRef}
                    className="promo-slider"
                    style={{
                        display: 'flex',
                        gap: '20px',
                        overflowX: 'auto',
                        scrollSnapType: 'x mandatory',
                        WebkitOverflowScrolling: 'touch',
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none'
                    }}
                >
                    {promotionImages.map((promo, index) => (
                        <div
                            key={promo.id}
                            className="promo-slide-item"
                            onClick={() => openImageModal(promo)}
                            style={{
                                position: 'relative',
                                flex: '0 0 calc(33.333% - 14px)',
                                scrollSnapAlign: 'start',
                                borderRadius: '12px',
                                overflow: 'hidden',
                                boxShadow: '0 8px 20px rgba(0,0,0,0.1)',
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: animatedElements['promotions'] ? 1 : 0,
                                transform: animatedElements['promotions'] ? 'translateY(0)' : 'translateY(30px)',
                                transitionDelay: `${index * 0.1}s`,
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-10px)';
                                e.currentTarget.style.boxShadow = '0 12px 30px rgba(76, 149, 108, 0.3)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.1)';
                            }}
                        >
                            <img
                                src={`/assets/img/${promo.image}`}
                                alt={promo.alt}
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    display: 'block',
                                    objectFit: 'cover',
                                }}
                            />
                            <div style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                right: 0,
                                background: 'linear-gradient(to top, rgba(0,0,0,0.7), transparent)',
                                color: 'white',
                                padding: '2rem 1rem 1rem',
                                opacity: 0,
                                transition: 'opacity 0.3s ease',
                            }}
                                className="hover-overlay">
                                <p style={{
                                    fontSize: '0.9rem',
                                    margin: 0,
                                    fontWeight: 500,
                                }}>
                                    點擊查看詳情
                                </p>
                            </div>
                        </div>
                    ))}
                </div>

                <button
                    className="slider-nav-btn slider-right"
                    onClick={() => scrollSlider(1)}
                    aria-label="Next"
                >
                    ›
                </button>
            </div>
            */}

            {/* 圖片放大模態框 (保持原樣即可) */}
            {selectedImage && (
                <div
                    onClick={closeImageModal}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        background: 'rgba(0, 0, 0, 0.9)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 2000,
                    }}
                >
                    <div style={{
                        position: 'relative',
                        maxWidth: '100%',
                        maxHeight: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}>
                        <img
                            src={`/assets/img/${encodeURIComponent(selectedImage.image)}`}
                            alt={selectedImage.alt}
                            style={{
                                maxWidth: '85%',
                                maxHeight: '70vh',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                display: 'block',
                            }}
                        />

                        {/* 關閉按鈕 */}
                        <button
                            onClick={closeImageModal}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                background: 'rgba(255, 255, 255, 0.8)',
                                border: 'none',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.5rem',
                                color: colors.primary,
                                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                backdropFilter: 'blur(4px)',
                            }}
                        >
                            ×
                        </button>
                    </div>
                </div>
            )}
        </section>
    );
}
